export enum RestrictionType {
    RequestLenses = 0
}
